var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weather-page"},[(_vm.currentReportType.id == 2)?[_c('weather-satellite-page')]:_vm._e(),(_vm.currentReportType.id == 3)?[_c('weather-meteorology-page')]:_vm._e(),(_vm.currentReportType.id == 4)?[_c('weather-maps-page')]:_vm._e(),(_vm.currentReportType.id == 5)?[_c('weather-agrometeorology-page')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }